import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuard} from '@modules/shared/guard';
import { ExploreResourcesComponent } from './explore-resources/explore-resources.component';

// TODO: ** new and edit que sean el mismo

const routes: Routes = [
  {
    path: '',
    component: ExploreResourcesComponent,
    data: {name: 'explore'},
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExploreRoutingModule { }
